import ErrorMessage from './ErrorMessage';
import LockIcon from '@mui/icons-material/Lock';
import useT from '@hooks/useT';

function ForbiddenError() {
  const { t } = useT('errors');
  return (
    <ErrorMessage
      title={t('components.forbidden.title')}
      message={t('components.forbidden.message')}
      icon={<LockIcon />}
      severity="error"
    />
  );
}

export default ForbiddenError;
